import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.step"],
  step => step
);
